var _rect, _path, _rect2, _path2, _path3, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.446167,
    width: 41,
    height: 40,
    rx: 8,
    fill: "#B3EFEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.6962C15.5 15.1049 16.1321 13.5787 17.2574 12.4535C18.3826 11.3283 19.9087 10.6962 21.5 10.6962C23.0913 10.6962 24.6174 11.3283 25.7426 12.4535C26.8679 13.5787 27.5 15.1049 27.5 16.6962C27.5 18.2875 26.8679 19.8136 25.7426 20.9388C24.6174 22.064 23.0913 22.6962 21.5 22.6962C19.9087 22.6962 18.3826 22.064 17.2574 20.9388C16.1321 19.8136 15.5 18.2875 15.5 16.6962ZM27.8656 11.4462C26.3516 9.61335 24.0641 8.44617 21.5 8.44617C18.9359 8.44617 16.6484 9.61335 15.1344 11.4462H12.5C10.8453 11.4462 9.5 12.7915 9.5 14.4462V29.4462C9.5 31.1009 10.8453 32.4462 12.5 32.4462H30.5C32.1547 32.4462 33.5 31.1009 33.5 29.4462V14.4462C33.5 12.7915 32.1547 11.4462 30.5 11.4462H27.8656ZM23.375 18.9462C23.375 18.4493 23.1828 17.9993 22.8641 17.6618L24.4391 13.9915C24.6031 13.6118 24.425 13.1712 24.0453 13.0071C23.6656 12.843 23.225 13.0212 23.0609 13.4009L21.4859 17.0712C20.4547 17.0759 19.625 17.9149 19.625 18.9462C19.625 19.9821 20.4641 20.8212 21.5 20.8212C22.5359 20.8212 23.375 19.9821 23.375 18.9462Z",
    fill: "#00C1B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23.9462,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#00C1B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 31.1462L30.5 27.7462",
    stroke: "#B3EFEB",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29.4462H32.5",
    stroke: "#B3EFEB",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23.9462,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "#B3EFEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFat);
export default __webpack_public_path__ + "static/media/fat.f3123439fabe4052e9adc9da690071d6.svg";
export { ForwardRef as ReactComponent };